import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { InAppBrowserOptions, InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the WebviewpagesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-webviewpages',
  templateUrl: 'webviewpages.html',
})
export class WebviewpagesPage {

  options : InAppBrowserOptions = {
    location : 'yes',//Or 'no' 
  }
   target : "_blank";
  url:any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private iab: InAppBrowser) {
    this.url = this.navParams.get('url');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HowToPlayWebviewPage');

    const browser = this.iab.create(this.url, this.target, this.options);

    this.navCtrl.pop();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/webviewpages/webviewpages.ts